import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { NavItemsConfig } from "./DrawerConfiguration";
import { RootState } from "../../app/Store";
import NavigationDrawer from "../NavigationDrawer/NavigationDrawer";
import { selectSiteId } from "../../sites/SiteStore";

import type { SiteGroupNavigation } from "../Layout";
import { siteGroupPath } from "../../site_groups/SiteGroupRoutes";

export default function SiteNavigationDrawer({ siteGroup }: { siteGroup?: SiteGroupNavigation }) {
  const location = useLocation();
  const siteId = useSelector(selectSiteId);
  const currentSiteMetadata = useSelector((state: RootState) => state.multiSitesMetadata.sites[siteId]);
  const currentSiteFeatureFlags = useSelector(
    (state: RootState) => state.featureFlags.sitesFeatureFlags[siteId]
  );
  const currentSiteProducts = useSelector(
    (state: RootState) => state.purchasedProducts?.productsBySite[siteId]
  );
  const userLevel = useSelector((state: RootState) => state.user.userType);
  const filterArgs = {
    siteFeatureFlags: currentSiteFeatureFlags,
    siteMetadata: currentSiteMetadata,
    userAccessType: userLevel,
    siteProducts: currentSiteProducts,
  };
  if (siteGroup) {
    return (
      <NavigationDrawer
        navigationItems={[{ ...NavItemsConfig[0], pagePath: siteGroupPath(siteGroup) }]}
      />
    );
  }
  const filteredDrawerItems = NavItemsConfig.filter((item) => item.visibilityFilter(filterArgs)).map(
    (item) =>
      item.getNavigationLabel ? { ...item, pageName: item.getNavigationLabel(filterArgs) } : item
  );
  const editedSiteName = "/" + encodeURI(currentSiteMetadata.siteCode);
  return (
    <NavigationDrawer
      navigationItems={filteredDrawerItems}
      navigationPrefix={editedSiteName}
      siteGroupId={location.state?.siteGroupId}
    />
  );
}
